export default __webpack_public_path__ + "static/media/ourWig-bandFall.2b5556bc.jpeg";